/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Qr_Pick_SubtitleInputs */

const vi_grower_area_qr_pick_subtitle = /** @type {(inputs: Grower_Area_Qr_Pick_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vùng trồng cần lấy mã QR`)
};

/**

* @param {Grower_Area_Qr_Pick_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_qr_pick_subtitle = /** @type {((inputs?: Grower_Area_Qr_Pick_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Qr_Pick_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_qr_pick_subtitle(inputs)
});